define("auth/routes/accept_membership", ["exports", "@ember/routing/route", "@ember/object/computed", "@ember/object", "@ember/service", "rsvp"], function (_exports, _route, _computed, _object, _service, _rsvp) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  let AcceptMembershipRoute = (_dec = (0, _computed.alias)('auth.currentUserModel'), (_class = class AcceptMembershipRoute extends _route.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "alerts", _descriptor, this);

      _initializerDefineProperty(this, "auth", _descriptor2, this);

      _initializerDefineProperty(this, "intl", _descriptor3, this);

      _initializerDefineProperty(this, "session", _descriptor4, this);

      _initializerDefineProperty(this, "store", _descriptor5, this);

      _initializerDefineProperty(this, "currentUser", _descriptor6, this);
    }

    model(params) {
      return this.store.findRecord('membership', params.membership_id).then(membership => {
        if (this.session.get('isAuthenticated') && membership.belongsTo('user').id() != this.currentUser.get('id')) {
          this.auth.logout('?redirectUrl=' + window.location.pathname);
        } else {
          return membership;
        }
      }, () => {
        if (this.auth.currentUserModel) {
          this.transitionToExternal('cluster.schedule');
        } else {
          return new _rsvp.default.Promise(() => {
            this.auth.logout('?redirectUrl=' + window.location.pathname);
          });
        }
      });
    }

    redirect(model) {
      const self = this;
      const membership = model;
      membership.get('group').then(group => {
        if (membership.get('invited') == true && membership.belongsTo('user').id() == this.currentUser.get('id')) {
          membership.set('invited', false);
          membership.save().then(() => {
            self.transitionToExternal('cluster.collect.contribute', group.get('slug'));
          });
        } else if (membership.get('invited') == false) {
          this.auth.set('currentGroup', group);
          this.transitionToExternal('cluster.collect.contribute', group.get('slug'));
        } else if (this.session.get('isAuthenticated')) {
          this.alerts.info(this.intl.t('alerts.contributors.accept_invite.sign_in'), {
            sticky: true
          });
          this.auth.logout('?redirectUrl=' + window.location.pathname);
        } else {
          this.transitionToExternal('cluster.schedule');
        }
      });
    }

    error() {
      return false;
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "session", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "store", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "currentUser", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "error", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "error"), _class.prototype)), _class));
  _exports.default = AcceptMembershipRoute;
});